module.exports = __webpack_public_path__ + "img/telegram.449b2ac6.png";